<template>
  <div>
    <div id="scientific_activity_events">
      <b-card no-body class="quick-links-section custom-tab">
        <!-- <span class="mt-4 ml-3 lyon-display-medium-24">Scientific Activities</span> -->
        <b-tabs card lazy>
          <b-tab
            :disabled="!['all_events', '', null].includes(getActiveTab) && loading"
            title="All"
            :active="['all_events', '', null].includes(getActiveTab)"
            @click.prevent="loadAllEvents('all_events')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :past-data="pastEvents"
              :merged-data="mergedData"
              :upcoming-pagination="upcomingEventsPagination"
              :past-pagination="pastEventsPagination"
              :loading="loading"
              :tab-id="'all_events'"
              :event="'all_events'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <b-tab
            :disabled="getActiveTab !== 'programs' && loading"
            title="Programs"
            :active="getActiveTab === 'programs'"
            @click.prevent="loadSelectedEvents('programs', 'programs')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'programs'"
              :event="'Program'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
					<b-tab
            :disabled="getActiveTab !== 'axiom' && loading"
            title="AxIOM"
            :active="getActiveTab === 'axiom'"
            @click.prevent="loadSelectedEvents('axiom', 'axioms')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'axioms'"
              :event="'AxIOM'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <b-tab
            :disabled="getActiveTab !== 'workshops' && loading"
            title="Workshops"
            :active="getActiveTab === 'workshops'"
            @click.prevent="loadSelectedEvents('workshops', 'workshops')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'workshops'"
              :event="'Workshop'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <b-tab
            :disabled="getActiveTab !== 'seminars' && loading"
            title="Seminars"
            :active="getActiveTab === 'seminars'"
            @click.prevent="loadSelectedEvents('seminars', 'seminars')"
          >
            <scientific-activity-tab-events
              :current-data="null"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'seminars'"
              :event="'Seminar'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <!-- <b-tab
            :disabled="getActiveTab !== 'adjoint' && loading"
            title="ADJOINT"
            :active="getActiveTab === 'adjoint'"
            @click.prevent="loadSelectedEvents('adjoint', 'adjoints')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'adjoints'"
              :event="'Adjoint'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab> -->
          <b-tab
            :disabled="getActiveTab !== 'msri_up' && loading"
            title="MSRI-UP"
            :active="getActiveTab === 'msri_up'"
            @click.prevent="loadSelectedEvents('msri_up', 'msri_ups')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'msri_ups'"
              :event="'MsriUp'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <b-tab
            :disabled="getActiveTab !== 'summer_school' && loading"
            title="SGS"
            :active="getActiveTab === 'summer_school'"
            @click.prevent="loadSelectedEvents('summer_school', 'summer_schools')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'summer_schools'"
              :event="'SummerSchool'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <!-- <b-tab
            :disabled="getActiveTab !== 'summer_research' && loading"
            title="Summer Research"
            :active="getActiveTab === 'summer_research'"
            @click.prevent="loadSelectedEvents('summer_research', 'summer_research_woman')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'summer_research_woman'"
              :event="'SummerResearchWoman'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab> -->
          <!-- <b-tab
            :disabled="getActiveTab !== 'may_up' && loading"
            title="MAY-UP"
            :active="getActiveTab === 'may_up'"
            @click.prevent="loadSelectedEvents('may_up', 'may_ups')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'may_ups'"
              :event="'MayUp'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab> -->
					<b-tab
            :disabled="getActiveTab !== 'proof' && loading"
            title="PROOF"
            :active="getActiveTab === 'proof'"
            @click.prevent="loadSelectedEvents('proof', 'proofs')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'proofs'"
              :event="'Proof'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
					<b-tab
            :disabled="getActiveTab !== 'lattice' && loading"
            title="LATTICE"
            :active="getActiveTab === 'lattice'"
            @click.prevent="loadSelectedEvents('lattice', 'lattices')"
          >
            <scientific-activity-tab-events
              :current-data="currentEvents"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="pastEventsPagination"
              :past-data="pastEvents"
              :loading="loading"
              :tab-id="'lattices'"
              :event="'Lattice'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
          <b-tab
            :disabled="getActiveTab !== 'public_events' && loading"
            title="Public Events"
            :active="getActiveTab === 'public_events'"
            @click.prevent="loadPublicEventsData('', 1, 'public_events')"
          >
            <scientific-activity-tab-events
              :current-data="null"
              :upcoming-data="upcomingEvents"
              :upcoming-pagination="upcomingEventsPagination"
              :merged-data="mergedData"
              :past-pagination="null"
              :past-data="null"
              :loading="loading"
              :tab-id="'public_events'"
              :event="'GeneralEvent'"
              :upcoming-pagination-loading="upcomingPaginationLoading"
              :past-pagination-loading="pastPaginationLoading"
              :show-past="showPast"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import ScientificActivityTabEvents from "./ScientificActivityTabEvents.vue"
import { mapGetters } from "vuex"
import mixin from "@/utils/mixin.js"

export default {
	name: "ScientificActivityTab",
	components: { ScientificActivityTabEvents },
	mixins: [mixin],
	props: ["showPast"],
	data() {
		return {
			currentEvents: [],
			upcomingEvents: [],
			pastEvents: [],
			mergedData: [],
			upcomingEventsPagination: {},
			pastEventsPagination: {},
			loading: false,
			upcomingPaginationLoading: false,
			pastPaginationLoading: false,
			tabs: [
				"#all_events",
				"#programs",
				"#workshops",
				"#public_events",
				"#seminars",
				"#adjoint",
				"#msri_up",
				"#summer_school",
				"#summer_research",
				"#may_up",
				"proof",
				"lattice",
				"axiom",
			],
		}
	},
	computed: {
		...mapGetters(["getActiveTab", "isAuthenticated"]),
	},
	watch: {
		isAuthenticated() {
			this.loadDynamicEvents()
		},
	},
	async mounted() {
		if (this.tabs.indexOf(this.$route.hash) !== -1) {
			const hashPath = this.$route.hash
			this.setCurrentTab(hashPath.substring(1), "scientific_activity_events")
		} else {
			this.setCurrentTab("", "")
		}
		await this.$root.$on("updateSearchList", (event, searchValue, page, tabId) => {
			if (tabId === "all_events") {
				this.loadAllSearchEvents(event, searchValue, page, tabId)
			} else if (tabId === "public_events") {
				this.loadPublicEventsData(searchValue, page)
			} else {
				this.loadSearchEvents(event, searchValue, page, tabId)
			}
		})
		await this.$root.$on("updatePaginationList", (event, searchValue, page, pageType, tabId) => {
			if (tabId === "all_events") {
				this.loadAllPaginationEvents(event, searchValue, page, pageType, tabId)
			} else if (tabId === "public_events") {
				this.loadPublicEventsData(searchValue, page)
			} else {
				this.loadPaginationEvents(event, searchValue, page, pageType, tabId)
			}
		})
		this.loadDynamicEvents()
	},
	methods: {
		resetVar() {
			this.currentEvents = []
			this.upcomingEvents = []
			this.pastEvents = []
			this.upcomingEventsPagination = {}
			this.pastEventsPagination = {}
		},
		// for public events
		async loadPublicEventsData(searchValue, page, tabName) {
			this.loading = true
			this.upcomingPaginationLoading = true
			this.resetVar()
			if (tabName) {
				this.setCurrentTab(tabName, "scientific_activity_events")
			}
			const res = await this.$http.get(`${process.env.VUE_APP_API_URL}/workshops/home_public_events`, {
				params: {
					search_value: searchValue,
					page: page,
				},
			})
			if (res) {
				if (res.data.error !== undefined) {
					this.$toasted.global.error(res.data.error)
				} else {
					this.upcomingEvents = res.data.public_events.results
					this.upcomingEventsPagination = res.data.public_events.pagination
					this.mergedData = [...this.upcomingEvents]
					this.upcomingPaginationLoading = false
					this.loading = false
				}
			}
		},
		// for all events other then public
		loadSelectedEvents(tabName, apiName) {
			this.loading = true
			this.resetVar()
			this.setCurrentTab(tabName, "scientific_activity_events")
			this.loadCurrentEventsData(apiName)
			if (this.showPast) this.loadPastEventsData(apiName)
		},
		async loadCurrentEventsData(apiName) {
			this.loading = true
			const res = await this.$http.get(`${process.env.VUE_APP_API_URL}/${apiName}`, {
				params: {
					page: 1,
				},
			})
			if (res) {
				if (res.data.error !== undefined) {
					this.$toasted.global.error(res.data.error)
				} else {
					this.currentEvents = res.data.current.results
					this.upcomingEvents = res.data.upcoming.results
					this.upcomingEventsPagination = res.data.upcoming.pagination
					this.mergedData = [...this.currentEvents, ...this.upcomingEvents]
					if (!this.showPast) this.loading = false
				}
			}
		},
		async loadPastEventsData(apiName) {
			this.loading = true
			const res = await this.$http.get(`${process.env.VUE_APP_API_URL}/${apiName}/past`, {
				params: {
					page: 1,
				},
			})
			if (res) {
				if (res.data.error !== undefined) {
					this.$toasted.global.error(res.data.error)
				} else {
					this.pastEvents = res.data.past.results
					this.pastEventsPagination = res.data.past.pagination
					this.loading = false
				}
			}
		},
		loadSearchEvents(event, searchValue, page, tabId) {
			this.loading = true
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/${tabId}/search`, {
					params: {
						search_value: searchValue,
						page: page,
					},
				})
				.then((res) => {
					this.currentEvents = res.data.current.results
					this.upcomingEvents = res.data.upcoming.results
					this.upcomingEventsPagination = res.data.upcoming.pagination
					this.pastEvents = res.data.past.results
					this.pastEventsPagination = res.data.past.pagination
					this.mergedData = [...this.currentEvents, ...this.upcomingEvents]
					this.loading = false
				})
		},
		loadPaginationEvents(event, searchValue, page, pageType, tabId) {
			if (pageType === "upcomingPage") {
				this.upcomingPaginationLoading = true
			} else {
				this.pastPaginationLoading = true
			}
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/${tabId}/search`, {
					params: {
						search_value: searchValue,
						page: page,
					},
				})
				.then((res) => {
					if (pageType === "upcomingPage") {
						this.upcomingEvents = res.data.upcoming.results
						this.upcomingEventsPagination = res.data.upcoming.pagination
						this.mergedData = [...this.upcomingEvents]
						this.upcomingPaginationLoading = false
					} else {
						this.pastEvents = res.data.past.results
						this.pastEventsPagination = res.data.past.pagination
						this.pastPaginationLoading = false
					}
				})
		},
		// for all events
		loadAllEvents(tabName) {
			this.loading = true
			this.resetVar()
			if (tabName) {
				this.setCurrentTab(tabName, "scientific_activity_events")
			}
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/scientific_activities/scientific_activities_listing`)
				.then((res) => {
					this.currentEvents = res.data.current.results
					this.upcomingEvents = res.data.upcoming.results
					this.upcomingEventsPagination = res.data.upcoming.pagination
					this.mergedData = [...this.currentEvents, ...this.upcomingEvents]
					this.pastEvents = res.data.past.results
					this.pastEventsPagination = res.data.past.pagination
					this.loading = false
				})
		},
		loadAllSearchEvents(event, searchValue, page, tabId) {
			this.loading = true
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/scientific_activities/search`, {
					params: {
						search_value: searchValue,
						page: page,
					},
				})
				.then((res) => {
					this.currentEvents = res.data.current.results
					this.upcomingEvents = res.data.upcoming.results
					this.upcomingEventsPagination = res.data.upcoming.pagination
					this.mergedData = [...this.currentEvents, ...this.upcomingEvents]
					this.pastEvents = res.data.past.results
					this.pastEventsPagination = res.data.past.pagination
					this.loading = false
				})
		},
		loadAllPaginationEvents(event, searchValue, page, pageType, tabId) {
			if (pageType === "upcomingPage") {
				this.upcomingPaginationLoading = true
			} else {
				this.pastPaginationLoading = true
			}
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/scientific_activities/search`, {
					params: {
						search_value: searchValue,
						page: page,
					},
				})
				.then((res) => {
					if (pageType === "upcomingPage") {
						this.upcomingEvents = res.data.upcoming.results
						this.upcomingEventsPagination = res.data.upcoming.pagination
						this.mergedData = [...this.upcomingEvents]
						this.upcomingPaginationLoading = false
					} else {
						this.pastEvents = res.data.past.results
						this.pastEventsPagination = res.data.past.pagination
						this.pastPaginationLoading = false
					}
				})
		},
		loadDynamicEvents() {
			const hash = this.$route.hash.slice(1)
			switch (hash) {
				case "":
				case "all_events":
					this.loadAllEvents()
					break
				case "programs":
					this.loadSelectedEvents(hash, "programs")
					break
				case "workshops":
					this.loadSelectedEvents(hash, "workshops")
					break
				case "seminars":
					this.loadSelectedEvents(hash, "seminars")
					break
				case "adjoint":
					this.loadSelectedEvents(hash, "adjoints")
					break
				case "msri_up":
					this.loadSelectedEvents(hash, "msri_ups")
					break
				case "summer_school":
					this.loadSelectedEvents(hash, "summer_schools")
					break
				case "summer_research":
					this.loadSelectedEvents(hash, "summer_research_woman")
					break
				case "may_up":
					this.loadSelectedEvents(hash, "may_ups")
					break
				case "proof":
					this.loadSelectedEvents(hash, "proofs")
					break
				case "lattice":
					this.loadSelectedEvents(hash, "lattices")
					break
				case "axiom":
					this.loadSelectedEvents(hash, "axioms")
					break
				case "public_events":
					this.loadPublicEventsData("", 1, hash)
					break
				default:
					this.loadAllEvents()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.quick-links-section {
  border: 1px solid #F0E7E2;
  padding: 1.5rem;
  @media only screen and (max-width: 64rem) {
    padding: 0 !important;
  }
  @media (max-width: 47.9rem) {
    padding: 0 !important;
  }
}
</style>
